import React from "react";
import {Redirect, useLocation} from "react-router-dom";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import {useTranslation} from "react-i18next";
import {useGetProfileUserByEmail} from "../../services/UserDataManager";

/**
 * Punto di ingresso per i link provenienti dall'assistenza (Zoho Desk), dove l'utente
 * è identificato dall'email mentre Pin Bike lo identifica dall'uid.
 * Risolve l'email e rimbalza sulla scheda del pinbiker: /pinbiker-lookup?email=...
 */
export default function PinbikerLookup() {
    const {t} = useTranslation();
    const email = (new URLSearchParams(useLocation().search).get("email") || "").trim();
    const {status, profile} = useGetProfileUserByEmail(email);

    if (email && (status === "loading" || status === "idle")) {
        return (
            <Grid container justifyContent="center">
                <CircularProgress/>
            </Grid>
        );
    }

    // Redirect e non push: il link di rimbalzo non deve restare nella cronologia del browser.
    if (status === "success" && profile.uid) {
        return <Redirect to={`/profile/${profile.uid}/enrollments`}/>;
    }

    // Email assente nel link, oppure nessun utente associato: la navigazione per proseguire
    // è già quella di Main (header e sidebar), quindi qui basta dire cosa non ha funzionato.
    return (
        <Grid container>
            <Grid item xs={12}>
                <Box fontSize="h6.fontSize" textAlign="center">{t("userNotFound")}</Box>
            </Grid>
            {email && (
                <Grid item xs={12}>
                    <Box fontSize="body1.fontSize" textAlign="center" mt={1}>{email}</Box>
                </Grid>
            )}
        </Grid>
    );
}
